// extracted by mini-css-extract-plugin
module.exports = {"Btn":"CalculatorButton_Btn__3PwRb","BtnWrapper":"CalculatorButton_BtnWrapper__ZZiLs"};